const TIER_ONE_RESOLUTION_TYPE = {
  MANUAL: 'MANUAL',
  LLM: 'LLM',
}

export default TIER_ONE_RESOLUTION_TYPE
